// @flow
import type { SampleList } from "../../lib/OnlineTypes";
import React from "react";
import Samples from "../sample_reporting/Samples";
import styled from "styled-components";
import { findSamplesPost as findSamples } from "../../lib/SamplesData";
import { DefaultPaddedContainerNoShadow } from "./Theme";
import SampleActionBar from "../sample_reporting/SampleActionBar";

type Props = {
  sampleIds: Array<number>,
  company_id: number,
  showScheduledStatus: ?boolean,
  canSelect: ?Function,
  ToolbarComponent: ?Object,
  clientView: boolean,
  ExtraHeader: ?Object,
  ExtraBody: ?Object,
  showAttributes: ?boolean,
  onSampleSelectChange: ?Function,
  jobId: ?number,
  searchParams: ?Object,
};

type State = {
  sample_list: ?SampleList,
};

export default class FixedSampleList extends React.Component {
  static defaultProps = {
    samplesOptions: {},
    ToolbarComponent: SampleActionBar,
    canSelect: () => true,
    clientView: true,
    marginTop: 30,
    searchParams: {},
  };

  state = {
    sample_list: null,
  };

  fetchSamples() {
    const { company_id, sampleIds, searchParams } = this.props;
    findSamples(company_id, sampleIds, searchParams).then((sample_list) => {
      this.setState({ sample_list });
    });
  }

  componentDidMount() {
    this.fetchSamples();
  }

  render() {
    const {
      company_id,
      showScheduledStatus,
      ToolbarComponent,
      canSelect,
      clientView,
      ExtraHeader,
      ExtraBody,
      showAttributes,
      marginTop,
      onSampleSelectChange,
      jobId,
    } = this.props;
    const { sample_list } = this.state;
    return (
      <div>
        {sample_list ? (
          <div style={{ marginTop }}>
            <Samples
              ToolbarComponent={ToolbarComponent}
              sample_list={sample_list}
              company_id={company_id}
              showScheduledStatus={showScheduledStatus}
              canSelect={canSelect}
              clientView={clientView}
              ExtraHeader={ExtraHeader}
              ExtraBody={ExtraBody}
              showAttributes={showAttributes}
              onSampleSelectChange={onSampleSelectChange}
              reloadData={() => location.reload()}
              toolbarOptions={{ jobId }}
            />
          </div>
        ) : (
          <div style={{ marginTop: marginTop + 10 }}>
            <i className="fa fa-refresh fa-spin" />
            &nbsp; Loading...{" "}
          </div>
        )}
      </div>
    );
  }
}

window.FixedSampleList = FixedSampleList;
